import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import { navGroups } from '../components/navConfig';
import { PanelBreadcrumbProvider } from '../components/PanelBreadcrumbContext';
import { readPanelSidebarCollapsed, writePanelSidebarCollapsed } from '../utils/sidebarCollapse';
import '../styles.css';

const AdminPanelLayout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => readPanelSidebarCollapsed());

  useEffect(() => {
    writePanelSidebarCollapsed(sidebarCollapsed);
  }, [sidebarCollapsed]);

  return (
    <PanelBreadcrumbProvider>
      <div className="min-h-screen panel-gradient panel-font text-slate-800">
        <div className="flex min-h-screen">
          <Sidebar
            groups={navGroups}
            isOpen={sidebarOpen}
            onClose={() => setSidebarOpen(false)}
            collapsed={sidebarCollapsed}
            onToggleCollapsed={() => setSidebarCollapsed((current) => !current)}
          />
          <main className="flex-1 min-w-0">
            <Topbar groups={navGroups} onToggleSidebar={() => setSidebarOpen(true)} />
            <div className="p-4 sm:p-6">
              <div className="panel-container">
                <Outlet />
              </div>
            </div>
          </main>
        </div>
      </div>
    </PanelBreadcrumbProvider>
  );
};

export default AdminPanelLayout;
